/**
 * Строки по умолчанию, если ключ ещё не заведён в API переводов.
 * После добавления в БД значение из API перекроет fallback через $t().
 */
export const INTERFACE_TRANSLATION_FALLBACKS = {
	coursePackageAccessUntil: {
		en: "Access until",
		uk: "Доступ до",
	},
	videoLinkUnavailable: {
		en: "The video could not be loaded. Please contact your curator.",
		uk: "Не вдалося завантажити відео. Будь ласка, зверніться до куратора.",
	},
	newDesign: {
		en: "New design",
		uk: "Новий дизайн",
	},
	newDesignSwitching: {
		en: "Switching design…",
		uk: "Перемикаємо дизайн…",
	},
	newDesignSwitchFailed: {
		en: "Could not switch, please try again",
		uk: "Не вдалося перейти, спробуйте ще раз",
	},
	migrationBannerHeading: {
		en: "Try the new cabinet design",
		uk: "Спробуйте новий дизайн кабінету",
	},
	migrationBannerSubtext: {
		en: "A refreshed interface — faster and easier. Your progress is safe.",
		uk: "Оновлений інтерфейс — швидше та зручніше. Ваш прогрес на місці.",
	},
	migrationBannerCta: {
		en: "Go",
		uk: "Перейти",
	},
	migrationBannerClose: {
		en: "Close",
		uk: "Закрити",
	},
};

/**
 * @param {import('vue').default} vm
 * @param {string} key
 * @returns {string}
 */
export function interfaceT(vm, key) {
	const translated = vm.$t(key);
	if (translated && translated !== key) {
		return translated;
	}
	const lang = vm.$store?.getters?.currentLanguage?.translationKey || "en";
	const row = INTERFACE_TRANSLATION_FALLBACKS[key];
	if (!row) {
		return key;
	}
	return row[lang] || row.en || key;
}
